import React, { useState } from "react";
import { Link, Redirect } from "react-router-dom";
import * as yup from "yup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleLeft } from "@fortawesome/pro-regular-svg-icons/faArrowCircleLeft";

import { toast } from "react-toastify";
import { Helmet } from "react-helmet";

import { Heading } from "@peracto/peracto-ui";
import { CREATE, useClient, getSchemaFromResource } from "@peracto/client";

import { MODE_ADD } from "../BrandForm";

export const BrandAdd = ({ BrandForm }) => {
    const { client, getResource } = useClient();
    const [redirect, setRedirect] = useState();

    const schema = getSchemaFromResource(getResource("brands")).shape({
        name: yup.string().required(),
        displayOrder: yup.number().required(),
        code: yup.string().required("Brand Code is a required field"),
    });

    const onSubmit = async (data, actions) => {
        try {
            const parsedData = {
                ...data,
                displayOrder: parseInt(data.displayOrder),
            };

            const response = await client(CREATE, "brands", {
                data: parsedData,
            });

            if (
                response.data.violations &&
                response.data.violations.length > 0
            ) {
                // Display errors for invalid fields
                actions.setSubmitting(false);
                response.data.violations.forEach((error) => {
                    actions.setFieldError(error.propertyPath, error.message);
                });
            } else {
                setRedirect(response.data.id);
                toast.success("Brand successfully added!");
                actions.setSubmitting(false);
            }
        } catch (e) {
            console.error(e);
            toast.error(
                e?.error?.body?.hasOwnProperty("hydra:description")
                    ? e.error.body["hydra:description"]
                    : "Whoops, there was a problem..."
            );
            if (e?.error?.body?.violations?.length > 0) {
                // Display errors for invalid fields
                e.error.body.violations.forEach((error) => {
                    actions.setFieldError(error.propertyPath, error.message);
                });
            }
            actions.setSubmitting(false);
        }
    };

    if (redirect) {
        return <Redirect to={redirect} />;
    }

    return (
        <>
            <Helmet>
                <title>Brand | Add | Peracto</title>
            </Helmet>
            <div className="form-container">
                <Heading name="Add Brand">
                    <div className="flex-grow-1 d-flex align-items-center justify-content-end">
                        <Link
                            className="btn btn-outline-primary"
                            data-testid="back-to-brands"
                            to="/brands"
                        >
                            <FontAwesomeIcon
                                icon={faArrowCircleLeft}
                                className="mr-2"
                            />
                            Back to Brands
                        </Link>
                    </div>
                </Heading>
                <BrandForm
                    onSubmit={onSubmit}
                    mode={MODE_ADD}
                    schema={schema}
                />
            </div>
        </>
    );
};
